import { useMemo, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { iconsMap } from '@shared/assets/icons/map.tsx';
import {
  ColorTags,
  GroupsIconClient,
  Notes,
  Person,
  PhoneClientProfile,
} from '@shared/assets/index.ts';
import { IconInSquare } from '@shared/ui/smart-icons/IconInSquare/ui.tsx';
import { useAppDispatch } from '@src/library/hooks/common/index.ts';
import { useTabs } from '../../model';
import * as st from './styles.module.scss';

const pathName = window.location.pathname;

type onLinkClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;

const clientGeneralTabsInfo = [
  { displayName: 'Профиль', linkValue: 'info', state: {}, icon: <Person /> },
  { displayName: 'Контакты', linkValue: 'contacts', state: {}, icon: <PhoneClientProfile /> },
  { displayName: 'Заметки', linkValue: 'notes', state: {}, icon: <Notes /> },
  { displayName: 'Группы', linkValue: 'groups', state: {}, icon: <GroupsIconClient /> },
  { displayName: 'Теги', linkValue: 'colortag', state: {}, icon: <ColorTags /> },
].map((tab) => ({
  ...tab,
  state: {
    ...tab.state,
    path: pathName,
  },
})) as {
  displayName: string;
  linkValue: string;
  state: unknown;
  icon: ReactNode;
  onClick?: onLinkClick;
}[];

export const ClientTabsMobile = () => {
  const dispatch = useAppDispatch();

  const { clientModules } = useTabs();

  const clientGeneralTabs = useMemo(() => {
    return clientGeneralTabsInfo.map((tab) => {
      // if (tab.linkValue === 'contacts') {
      //   tab['onClick'] = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      //     event.preventDefault();
      //     dispatch(openNotReadyModuleNotify());
      //   };
      // }
      return tab;
    });
  }, [dispatch]);

  const clientModuleTabs = useMemo(() => {
    return clientModules.map((module) => {
      const { module_type, code, verbose_name } = module;
      return {
        displayName: verbose_name,
        linkValue: code,
        state: { path: pathName },
        icon: iconsMap[module_type],
      };
    });
  }, [clientModules]);

  return (
    <>
      <section className={st.generalTabs}>
        {clientGeneralTabs.map((tab, index) => {
          const { displayName, icon, linkValue, state, onClick } = tab;
          return (
            <Link key={index} className={st.tab} to={linkValue} state={state} onClick={onClick}>
              <IconInSquare icon={icon} />
              <p className={st.tabName}>{displayName}</p>
            </Link>
          );
        })}
      </section>

      <section className={st.moduleTabs}>
        {clientModuleTabs.map((tab, index) => {
          const { displayName, icon, linkValue, state } = tab;
          return (
            <Link key={index} className={st.tab} to={linkValue} state={state}>
              <IconInSquare icon={icon} />
              <p className={st.tabName}>{displayName}</p>
            </Link>
          );
        })}
      </section>
    </>
  );
};
